export const ROLE_LABEL: Record<string, string> = {
  STAFF: 'Staff',
  ADMIN: 'Admin Approver',
  IT_ADMIN: 'IT Administrator',
  FINANCE: 'Finance',
  FINANCE_LEAD: 'Finance Lead',
  HR: 'Human Resources',
};
